import * as t from 'io-ts';
import { fromEnum } from '../responseUtil';
import { ApiActivationStatus, SupplierCodec } from './activationsApi.types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ServiceProviderActivationCodec = t.intersection([
    t.type({
        activated_at: t.string,
        activation_status: fromEnum<ApiActivationStatus>('ApiActivationStatus', ApiActivationStatus),
    }),
    t.partial({
        service_provider_identification: t.string,
        interface_access_granted: t.boolean,
    }),
]);

export enum ApiTenant {
    VW_PROD = 'vw.prod',
    VW_QA = 'vw.qa',
    VW_TEST = 'vw.test',
    RIO_TEST = 'rio.test',
    LSP_TEST = 'lsp.test',
}

export enum ApiCompoundAccess {
    NONE = 'none',
    READ_ONLY = 'read-only',
    READ_WRITE = 'read-write',
}

const TenantCodec = fromEnum<ApiTenant>('ApiTenant', ApiTenant);

export const ServiceProviderCodec = t.intersection([
    t.type({
        account_id: t.string,
        supplier: SupplierCodec,
        service_provider_name: t.string,
        service_provider_identification: t.string,
        duns: t.string,
        interface_access_requested: t.boolean,
        activation_requested_at: t.string,
        activation_status: fromEnum<ApiActivationStatus>('ApiActivationStatus', ApiActivationStatus),
        compound_access: fromEnum<ApiCompoundAccess>('ApiCompoundAccess', ApiCompoundAccess),
        tenants: t.array(TenantCodec),
    }),
    t.partial({
        activated_at: t.string,
        client_id: t.string,
    }),
]);

export const ServiceProviderPageCodec = t.type({
    service_providers: t.array(ServiceProviderCodec),
    allowed_actions: t.array(t.string),
});

export type ApiServiceProviderActivation = t.TypeOf<typeof ServiceProviderActivationCodec>;
export type ApiServiceProvider = t.TypeOf<typeof ServiceProviderCodec>;
export type ApiServiceProviderPage = t.TypeOf<typeof ServiceProviderPageCodec>;
